import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IconButton from '@mui/material/IconButton';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
const TitlePage = ({ titlePage, btnBack = true, urlBack }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const goBack = () => {
        if (urlBack) {
            navigate(urlBack);
        }
        else {
            navigate(-1);
        }
    };
    return (_jsx("div", Object.assign({ className: "main-title-page" }, { children: _jsxs("div", Object.assign({ className: "container-xl main-title-page-wrapper" }, { children: [btnBack && (_jsx(IconButton, Object.assign({ className: "btn-back", color: "primary", "aria-label": t('common.btn.back'), onClick: goBack }, { children: _jsx(ArrowBackRoundedIcon, {}) }))), _jsx("h2", { children: t(titlePage) })] })) })));
};
export default TitlePage;
